module.exports = __webpack_public_path__ + "static/media/FuturaBT-Book.f9f02ed0.ttf";